import { Component, OnInit, Signal, computed } from '@angular/core';
import { analystSourcesWhiteList } from '@configurations/scenario/analyst-sources-white-list.configuration';
import { Source } from '@scenario/models/source.model';
import { dispatch, select } from '@store/injectables';
import {
  AnalystViewModel,
  retrieveAnalysts,
  retrievePsfUsers,
  selectAnalystViewModel,
} from '@store/scenario/analyst/analyst-slice';
import {
  SourcesViewModel,
  retrieveSources,
  selectSourcesViewModel,
} from '@store/scenario/sources/sources-slice';
import { AnalystSectionComponent } from '../analyst-section/analyst-section.component';
import { IconComponent } from '@totalenergiescode/tds-angular';

@Component({
  selector: 'app-manage-analyst',
  templateUrl: './manage-analyst.component.html',
  styleUrl: './manage-analyst.component.scss',
  imports: [AnalystSectionComponent, IconComponent],
})
export class ManageAnalystComponent implements OnInit {
  private readonly dispatch = dispatch();
  public readonly analystViewModel: Signal<AnalystViewModel> = select(selectAnalystViewModel);
  public readonly sourcesViewModel: Signal<SourcesViewModel> = select(selectSourcesViewModel);

  public readonly whiteListedSources = computed<Source[]>(() => {
    const sourcesByName = new Map(this.sourcesViewModel().sources.map(source => [source.name, source]));
    return analystSourcesWhiteList
      .map(name => sourcesByName.get(name))
      .filter((source): source is Source => source !== undefined);
  });

  ngOnInit(): void {
    this.dispatch(retrieveSources());
    this.dispatch(retrieveAnalysts());
    this.dispatch(retrievePsfUsers());
  }
}
